
// @ts-ignore
    import __i18nConfig from '@next-translate-root/i18n'
// @ts-ignore
    import __loadNamespaces from 'next-translate/loadNamespaces'
// @ts-ignore
    
import { captureException } from '@sentry/nextjs'
import cn from 'clsx'
import { useEffect, useState } from 'react'
import { useRouter } from 'next/router'
import Link from 'components/ui/Link'
import { OrderSummary } from '@components/checkout/OrderSummary'
import { LayoutWithHeader } from '@components/common/Layout/LayoutWithoutHeader'
import { isSuccess, useCart } from '@lib/api'
import { Logo } from '@components/ui'

import { sendEvent } from '@lib/tracking'
import { ShippingAddressView } from '@components/checkout/ShippingAddressView'
import { ShippingMethodView } from '@components/checkout/ShippingMethodView'
import { isCartInCheckoutState } from '@lib/api/cart/helpers'
import { Breadcrumb } from '@components/checkout/Breadcrumb/Breadcrumb'
import { isCheckoutStep } from '@lib/api/cart/types'
import { PaymentView } from '@components/checkout/PaymentView'
import { calculateTaxes } from '@components/checkout/helpers'
import { CheckoutFooter } from '@components/checkout/CheckoutFooter'
import { useCryptoConverterContext, useCryptoCurrencyContext } from '@lib/web3'

export default function Checkout() {
  const cartData = useCart()
  const router = useRouter()
  const [taxes, setTaxes] = useState<number | undefined>()
  const { selectedCoin } = useCryptoCurrencyContext()
  const { getSelectedCoinConversionRate } = useCryptoConverterContext()
  const [orderSummaryIsShown, setOrderSummaryIsShown] = useState(false)

  const conversionRate = getSelectedCoinConversionRate(selectedCoin)

  useEffect(() => {
    if (
      isSuccess(cartData) &&
      cartData.data?.state !== 'EnteringShippingAddress' &&
      cartData.data?.taxSummary !== undefined
    ) {
      setTaxes(calculateTaxes(cartData.data.taxSummary))
    } else {
      setTaxes(undefined)
    }
  }, [cartData])

  useEffect(() => {
    if (isSuccess(cartData) && !isCartInCheckoutState(cartData)) {
      router.push('/').catch((error) => {
        captureException(error)
        console.error(error)
      })
    }
  })

  const dataLoaded = isSuccess(cartData) && isCartInCheckoutState(cartData)
  const state = dataLoaded ? cartData.data?.state : undefined

  useEffect(() => {
    if (dataLoaded) {
      switch (state) {
        case 'EnteringShippingAddress':
          sendEvent({
            event: 'Checkout_Step_Reached',
            data: {
              stage: 'shipping_address',
            },
          })
          break
        case 'EnteringShippingMethod':
          sendEvent({
            event: 'Checkout_Step_Reached',
            data: {
              stage: 'shipping_method',
            },
          })
          break
        case 'ArrangingPayment':
          sendEvent({
            event: 'Checkout_Step_Reached',
            data: {
              stage: 'payment_page',
            },
          })
          break
        default:
          console.error('unknown cart state:', state)
      }
    }
  }, [dataLoaded, state])

  return (
    <div className="w-full flex">
      <div className="flex flex-col w-full lg:w-1/2">
        <div
          className={cn(
            'h-fit w-fit pt-9 mx-content-margin-mobile sm:mx-content-margin-desktop'
          )}
        >
          <Link href="/" aria-label="Logo">
            <Logo />
          </Link>
          <div className="mt-8">
            <Breadcrumb
              currentStep={
                isSuccess(cartData) &&
                cartData.data &&
                isCheckoutStep(cartData.data.state)
                  ? cartData.data.state
                  : undefined
              }
            />
          </div>
        </div>
        {conversionRate !== null ? (
          <div className="h-full flex-col flex lg:hidden">
            <OrderSummary
              isShown={orderSummaryIsShown}
              setIsShown={setOrderSummaryIsShown}
              cartData={cartData}
              taxes={taxes}
              className="grow"
              selectedCoin={selectedCoin}
              conversionRate={conversionRate}
            />
          </div>
        ) : null}
        <div className="mx-content-margin-mobile sm:mx-content-margin-desktop h-fit flex flex-col">
          <div
            className={cn('block', { 'hidden lg:block': orderSummaryIsShown })}
          >
            {!isSuccess(cartData) ? null : cartData.data?.state ===
              'EnteringShippingAddress' ? (
              <ShippingAddressView
                currentShippingAddress={cartData.data.shippingAddress}
                currentBillingAddress={cartData.data.billingAddress}
              />
            ) : cartData.data?.state === 'EnteringShippingMethod' ? (
              <ShippingMethodView />
            ) : cartData.data?.state === 'ArrangingPayment' &&
              cartData.data.shippingAddress &&
              cartData.data.billingAddress ? (
              <PaymentView
                shippingInfo={cartData.data.shippingAddress}
                billingInfo={cartData.data.billingAddress}
              />
            ) : null}
          </div>
        </div>
        <div className="flex w-full mt-auto">
          <CheckoutFooter className="mt-8 w-full" />
        </div>
      </div>
      {conversionRate !== null ? (
        <div className="h-full w-1/2 flex-col hidden lg:flex">
          <OrderSummary
            isShown={orderSummaryIsShown}
            setIsShown={setOrderSummaryIsShown}
            cartData={cartData}
            taxes={taxes}
            className="grow"
            selectedCoin={selectedCoin}
            conversionRate={conversionRate}
          />
        </div>
      ) : null}
    </div>
  )
}

Checkout.Layout = LayoutWithHeader


// @ts-ignore
    export async function getStaticProps(ctx) {
// @ts-ignore
        
// @ts-ignore
        
// @ts-ignore
        return {
// @ts-ignore
          
// @ts-ignore
          
// @ts-ignore
          props: {
// @ts-ignore
            
// @ts-ignore
            ...(await __loadNamespaces({
// @ts-ignore
              ...ctx,
// @ts-ignore
              pathname: '/checkout/index',
// @ts-ignore
              loaderName: 'getStaticProps',
// @ts-ignore
              ...__i18nConfig,
// @ts-ignore
              loadLocaleFrom: (l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default),
// @ts-ignore
            }))
// @ts-ignore
          }
// @ts-ignore
        }
// @ts-ignore
    }
// @ts-ignore
  